import { Component, computed, input, model, OnInit, output } from '@angular/core';
import sortBy from 'lodash/sortBy';
import { ExpandedPaperType } from '../../../models/client-models/entities/expanded-paper-type';

@Component({
  selector: 'app-paper-type-selection',
  templateUrl: './paper-type-selection.component.html',
  styleUrls: ['./paper-type-selection.component.scss'],
  standalone: false,
})
export class PaperTypeSelectionComponent implements OnInit {
  paperTypes = input.required<ExpandedPaperType[]>();

  paperTypesSorted = computed(() => {
    return sortBy(this.paperTypes(), (p) => p.priority);
  });

  selectedPaperType = model<ExpandedPaperType | null>(null);

  doNextStep = output<void>();

  ngOnInit() {}

  onPaperTypeClick(paperType: ExpandedPaperType) {
    this.selectedPaperType.set(paperType);
  }

  onDoubleClick() {
    this.doNextStep.emit();
  }
}
